module.exports = __webpack_public_path__ + "media/4x3/ag-cce32c73.svg";